import { sortBy } from 'lodash';
import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const createMainSheet = (inventoryListTemplates, clientStoreName) => {
  const columns = [
    {
      propertyKey: 'name',
      name: i18next.t('GENERAL.NAME'),
    },
    {
      propertyKey: 'storeName',
      name: clientStoreName,
    },
    {
      propertyKey: 'associatedSPsCount',
      name: i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.ASSOCIATED_SUPPLIER_PRODUCTS_COUNT_COLUMN'),
    },
    {
      propertyKey: 'associatedRecipesCount',
      name: i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.ASSOCIATED_ENTITIES_COUNT_COLUMN'),
    },
  ];

  const sortedILTs = sortBy(inventoryListTemplates, ({ name }) => name.toLowerCase());

  return utilsXLS.generateDefaultSheet(
    i18next.t('FEATURE.ADMIN.INVENTORY_LIST_TEMPLATES'),
    columns,
    sortedILTs,
  );
};

const exportInventoryListTemplates = (inventoryListTemplates, clientStoreName) => {
  const filename = i18next.t('ADMIN.INVENTORY_LIST_TEMPLATES.EXPORT_LIST_FILENAME');

  const mainSheet = createMainSheet(inventoryListTemplates, clientStoreName);

  utilsXLS.makeXLS(filename, [mainSheet]);
};

export default { exportInventoryListTemplates };
